import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';

export default function ChatInput({ onSend, disabled }) {
  const [value, setValue] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
    }
  }, [value]);

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend(value.trim());
      setValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const canSend = Boolean(value.trim()) && !disabled;

  return (
    <div className="flex items-end gap-2 px-3 py-3 border-t border-white/[0.07] bg-[#0d0d10] flex-shrink-0">
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder="Ask anything…"
        rows={1}
        className="flex-1 resize-none bg-white/[0.05] border border-white/[0.1] rounded-xl px-3.5 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-blue-500/50 focus:bg-white/[0.07] transition-all disabled:opacity-40"
        style={{ minHeight: '42px', maxHeight: '120px' }}
      />
      <button
        onClick={handleSend}
        disabled={!canSend}
        className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
          canSend
            ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-[0_4px_14px_rgba(59,130,246,0.4)] hover:shadow-[0_4px_20px_rgba(59,130,246,0.55)] hover:scale-105 active:scale-95'
            : 'bg-white/[0.05] text-gray-600 cursor-not-allowed'
        }`}
      >
        <Send className="w-4 h-4" />
      </button>
    </div>
  );
}
